import { useState } from 'react';
import styles from './EvalExplainerModal.module.css';

// BP-TOUR-EVAL-01: slides defined as a local config so BP-PLACEMENT-1C
// can push a third entry ({ id: 'review', ... }) without restructuring.
const SLIDES = [
  {
    id: 'intro',
    eyebrow: 'GETTING STARTED',
    headline: 'Time to meet the crew!',
    body: "It's time to read your first story! This story will not only introduce you to everyone, but will also help us understand which characters you're already familiar with and which ones still need some practice within the curriculum.",
    cta: 'Next',
    topVariant: 'buddy',
  },
  {
    id: 'reader',
    eyebrow: 'HOW IT WORKS',
    headline: 'Tap a character to find out more about it.',
    body: "While you read, you can click or tap any character in the story to learn about its meaning and how it's written.",
    cta: 'Next',
    topVariant: 'video',
    videoSrc: '/assets/eval/eval-reader-demo.mp4',
  },
  {
    id: 'review',
    eyebrow: 'HOW IT WORKS',
    headline: 'Tell us which characters you still found hard',
    body: "Once you have finished reading the story, take a brief moment with your parent to mark the characters you're still practicing or didn't know. You can mark as many as you want. This helps us understand where you're currently at and tailor the next stories exactly to your progress.",
    cta: 'Meet the Crew!',
    topVariant: 'video',
    videoSrc: '/assets/eval/eval-review-demo.mp4',
  },
];

export default function EvalExplainerModal({ buddyAvatar, onComplete }) {
  const [index, setIndex] = useState(0);
  const slide = SLIDES[index];
  const isLast = index === SLIDES.length - 1;

  function handleCta() {
    if (isLast) {
      onComplete();
      return;
    }
    setIndex((i) => i + 1);
  }

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Eval story intro">
      <div className={styles.modal}>
        <div
          className={`${styles.topHalf} ${
            slide.topVariant === 'buddy' ? styles.topBuddy : styles.topVideo
          }`}
        >
          {slide.topVariant === 'buddy' && (
            <img
              src={`/assets/onboarding/${buddyAvatar || 'ling'}.webp`}
              alt=""
              aria-hidden="true"
              className={styles.buddyImg}
            />
          )}
          {slide.topVariant === 'video' && (
            <video
              key={slide.id}
              autoPlay
              loop
              muted
              playsInline
              src={slide.videoSrc}
              className={styles.demoVideo}
            />
          )}
        </div>

        <div className={styles.bottomHalf}>
          <div className={styles.copyBlock}>
            <div className={styles.headlineGroup}>
              <p className={styles.eyebrow}>{slide.eyebrow}</p>
              <h2 className={styles.headline}>{slide.headline}</h2>
            </div>
            <p className={styles.body}>{slide.body}</p>
          </div>

          <button type="button" className={styles.btnCta} onClick={handleCta}>
            {slide.cta}
          </button>
        </div>
      </div>
    </div>
  );
}
